import { Routes } from '@angular/router';
import { AuthGuard } from './auth.guard';
import { BaseLayoutComponent } from './fixedLayout/base-layout/base-layout.component';
import { LoginComponent } from './login/login.component';
import { PagenotfoundComponent } from './pagenotfound/pagenotfound.component';
import { ResetPasswordComponent } from './reset-password/reset-password.component';

export const AppRoutes: Routes = [
  { path: "", redirectTo: "/login", pathMatch: "full" },
  { path: "login", component: LoginComponent },
  { path: 'reset-password', component: ResetPasswordComponent },
  {
    path: 'homepage',
    component: BaseLayoutComponent,
    children: [
      {
        path: 'my-task-list',
        loadComponent: () => import('./my-task-list/my-task-list.component').then(m => m.MyTaskListComponent),
        canActivate: [AuthGuard]
      },
      {
        path: 'assign-task-list',
        loadComponent: () => import('./assign-task-list/assign-task-list.component').then(m => m.AssignTaskListComponent),
        canActivate: [AuthGuard]
      },
      {
        path: 'review-task-list',
        loadComponent: () => import('./review-task-list/review-task-list.component').then(m => m.ReviewTaskListComponent),
        canActivate: [AuthGuard]
      },
      {
        path: 'person-management',
        loadComponent: () => import('./person-management/person-management.component').then(m => m.PersonManagementComponent),
        canActivate: [AuthGuard]
      },
      {
        path: 'task-report',
        loadComponent: () => import('./task-report/task-report.component').then(m => m.TaskReportComponent),
        canActivate: [AuthGuard]
      },
      {
        path: 'leave-report',
        loadComponent: () => import('./leave-report/leave-report.component').then(m => m.LeaveReportComponent),
        canActivate: [AuthGuard]
      },
      {
        path: 'team-lead',
        loadComponent: () => import('./team-lead/team-lead.component').then(m => m.TeamLeadComponent),
        canActivate: [AuthGuard]
      },
      {
        path: 'projects',
        loadComponent: () => import('./project-management/project-management.component').then(m => m.ProjectManagementComponent),
        canActivate: [AuthGuard]
      },
      {
        path: 'profile',
        loadComponent: () => import('./profile/profile.component').then(m => m.ProfileComponent),
        canActivate: [AuthGuard]
      },
      {
        path: 'employee-timeline',
        loadComponent: () => import('./employee-timeline/employee-timeline.component').then(m => m.EmployeeTimelineComponent),
        canActivate: [AuthGuard]
      },
      {
        path: 'workingdays-report',
        loadComponent: () => import('./working-days-report/working-days-report.component').then(m => m.WorkingDaysReportComponent),
        canActivate: [AuthGuard]
      },
      {
        path: 'project-report',
        loadComponent: () => import('./project-report/project-report.component').then(m => m.ProjectReportComponent),
        canActivate: [AuthGuard]
      },
      {
        path: 'leadproject-report',
        loadComponent: () => import('./leadproject-report/leadproject-report.component').then(m => m.LeadprojectReport),
        canActivate: [AuthGuard]
      },
      {
        path: 'allocation-report',
        loadComponent: () => import('./allocation-report/allocation-report').then(m => m.AllocationReport),
        canActivate: [AuthGuard]
      },
      {
        path: "**",
        component: PagenotfoundComponent,
        canActivate: [AuthGuard]
      }
    ]
  },
  {
    path: "**", component: PagenotfoundComponent

  }
];
